<app-spinner [loading]="spinning()"></app-spinner>
<section class="main-table">
  <div class="main-table__header">
    <h1 class="main-table__title">{{labels.title}}</h1>
    @if (isEditor()) {
      <button mat-button class="button main-table__button" (click)="onCreate()">{{labels.createButton}}</button>
    }
  </div>
  <app-total class="main-table__total" [value]="total()"></app-total>
  <app-table class="main-table__table" [columnDefs]="columnDefs()" [rowData]="gridData().rowData" [gridOptions]="{}"
    (dataRequest)="onDataRequest($event)" [paginationState]="gridData().paginationState" (filtersChanged)="onFilterChanged($event)" (sortChanged)="onSortChanged($event)" [filter]="gridData().filter" [sort]="gridData().sort"></app-table>
</section>
